export const ROOT_INDEX = '/';
export const LOGIN_INDEX = '/login';
export const SSO_INDEX = '/sso';
export const SUPPORT_LOGIN_INDEX = '/support_login';
export const FORGOT_PASSWORD_INDEX = '/forgot_password';
export const RESET_PASSWORD_INDEX = '/reset_password';
export const DEFAULT_REDIRECT_AFTER_LOGIN = '/app/#/';
export const NOT_AUTHORIZED_INCYDR_INDEX = '/not_authorized';
export const SSO_INCORRECT_LOGIN = '/sso_incorrect_login';
export const SSO_SUCCESS_CP3 = '/sso_login_success_cp3';
export const SSO_INCORRECT_LOGIN_TRY_AGAIN = '/sso_incorrect_login_try_again';
export const SUPPORT_SSO_ERROR = '/support_sso_error';
